<template>
  <div class="app-footer__business-hours">
    <div class="app-footer__title">
      Stadtwerke Ahrensburg Kundenzentrum
    </div>
    <div class="icon-row">
      <div>
        <FontAwesomeIcon :icon="faLocationDot"/>
      </div>
      <div class="col">
        Lohe 1, 22926 Ahrensburg
      </div>
    </div>
    <table>
      <tr>
        <td>
          Mo. & Do.
        </td>
        <td>
          09:00 - 18:00 Uhr
        </td>
      </tr>
      <tr>
        <td>
          Di. & Mi.
        </td>
        <td>
          09:00 - 13:00 Uhr
        </td>
      </tr>
      <tr>
        <td>
          Freitag
        </td>
        <td>
          09:00 - 12:00 Uhr
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';

library.add(faLocationDot);
</script>

<style scoped lang="scss">
@import "src/scss/component-helpers";

.icon-row + table {
  margin-top: .625rem;

  @media (min-width: map_get($grid-breakpoints, 'lg')) {
    margin-top: 1rem;
  }
}
</style>
